module.exports = __webpack_public_path__ + "static/carrots-aad0843c61570d73978449e0b9d84aab.jpg";